import FullScreenPanel from './FullScreenPanel.jsx';

export default FullScreenPanel;



// WEBPACK FOOTER //
// ./src/components/Header/MoveableDiv/SearchBar/SearchBarSmall/SearchBarPanel/FullScreenPanel/index.js